const Producer = 'owner';
const Consumer = 'team-member';
const LevelTwo = 'level-two';
const { fetchDomainConfiguration } = require('../utils/common/DomainConfiguration');
const domain = fetchDomainConfiguration();
const check = domain.domainPath === 'admin' ? true : false;

module.exports = {
    check: {
        testCheck: check,
    },
    HTTP_CODE: {
        SUCCESS: 200,
        INSERT_SUCESS: 201,
        AUTHENTICATION_FAILURE: 401,
        REQUIRED_MISSING: 403,
        REQUEST_TIMED_OUT_FAILURE: 500,
        INPUT_VALIDATION_ERROR: 400,
        NO_DATA_FOUND: 404,
    },
    ACTION_TYPES: {
        MESSAGE_READ: 'on_read',
        TYPING_INDICATOR: 'TYPING_INDICATOR',
        PROFILE_UPDATE: 'PROFILE_UPDATE',
        LOGOUT_USER: 'LOGOUT_USER',
        LOGIN_USER: 'LOGIN_USER',
        LOGIN_ADMIN: 'LOGIN_ADMIN',
        FORGET_PASSWORD: 'FORGET_PASSWORD',
        CHANGE_PASSWORD: 'CHANGE_PASSWORD',
        SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
        CLEAR_NOTIFICATION: 'CLEAR_NOTIFICATION',
        GET_USER_INFORMATION: 'GET_USER_INFORMATION',
        ADD_USER_CONTACT_INFORMATION: 'ADD_USER_CONTACT_INFORMATION',
        NETWORK_CHNAGE: 'NETWORK_CHNAGE',
        INACTIVE_USER: 'INACTIVE_USER',
        DEACTIVATE_USER_SCREEN: 'DEACTIVATE_USER_SCREEN',
        NETWORK_PROBLEM: 'NETWORK_PROBLEM',
        SOCKET_SERVER_DOWN_PROBLEM: 'SOCKET_SERVER_DOWN_PROBLEM',
        PROFILE_IMAGE: 'PROFILE_IMAGE',
        EDUCATOR_MUTE_MESSAGE: 'EDUCATOR_MUTE_MESSAGE',
        UPDATE_UNREAD_MESSAGE_COUNT: 'UPDATE_UNREAD_MESSAGE_COUNT',
        WHITE_BOARD_DRAW: 'WHITE_BOARD_DRAW',
        WHITE_BOARD_OPEN: 'WHITE_BOARD_OPEN',
        WHITE_BOARD_FILE_URL: 'WHITE_BOARD_FILE_URL',
        ANONYMOUS_USER_DETAILS: 'ANONYMOUS_USER_DETAILS',
        ANONYMOUS_SIDE_DOCTOR_END_CALL: 'ANONYMOUS_SIDE_DOCTOR_END_CALL',
        UPDATE_LATEST_MESSAGE:"UPDATE_LATEST_MESSAGE",
        INS_SUPER_ADMIN: {
            INSTITUTION_LIST: 'GET_INSTITUTION_LIST',
            TOP_LEVEL_LIST: 'TOP_LEVEL_LIST',
            STUDENTS_LIST: 'STUDENTS_LIST',
            EDUPARENT_LIST: 'EDUPARENT_LIST',
            REJECT_TUTOR: 'REJECT_TUTOR',
            USER_LIST: 'GET_USER_LIST',
            USER_VERIFY: 'USER_VERIFY',
            ADMIN_NOTIFICATION: 'ADMIN_NOTIFICATION',
            READ_NOTIFICATION: 'READ_NOTIFICATION',
        },
        BRANCH_ADMIN: {
            GET_STUDENT: 'GET_STUDENT_LIST',
            GET_STATUS: 'GET_STATUS',
            GET_STUDENT_VISITS: 'GET_STUDENT_VISITS',
            GET_SUBJECT_LIST: 'GET_SUBJECT_LIST',
            GET_EXPERTISE_LEVEL: 'GET_EXPERTISE_LEVEL',
            GET_SESSION_LIST: 'GET_SESSION_LIST',
        },
        IM_PHYSICIAN: {
            GET_VISIT_INFORMATION: 'GET_VISIT_INFORMATION',
            GET_VONAGE_SESSION_DETAILS: 'GET_VONAGE_SESSION_DETAILS',
        },
        PHYSICIAN: {
            userIds: 'userIds',
            SHOWTIMER: 'SHOWTIMER',
            GET_PATIENT_INFO: 'GET_PATIENT_INFO',
            GET_KID_INFO: 'GET_KID_INFO',
            GET_PATIENT_VISIT_LIST: 'GET_PATIENT_VISIT_LIST',
            GET_FULL_PATIENT_VISIT_LIST: 'GET_FULL_PATIENT_VISIT_LIST',
            DROPDOWN_SESSION: 'DROPDOWN_SESSION',
            GET_PATIENT_CHAT_LIST: 'GET_PATIENT_CHAT_LIST',
            GET_PATIENT_VISIT_ENCOUNTER: 'GET_PATIENT_VISIT_ENCOUNTER',
            GET_PATIENT_SAVE_SOAP: 'GET_PATIENT_SAVE_SOAP',
            REMOVE_PATIENT_SAVE_SOAP: 'REMOVE_PATIENT_SAVE_SOAP',
            DASHBOARD: 'DASHBOARD',
            GET_VISIT_INFORMATION: 'GET_VISIT_INFORMATION',
            GET_STUDENT_INFORMATION: 'GET_STUDENT_INFORMATION',
            GET_PHYSICIAN_HANDOUT: 'GET_PHYSICIAN_HANDOUT',
            UPDATE_WATING_ROOM_SOCKET_SUCESS: 'UPDATE_WATING_ROOM_SOCKET_SUCESS',
            VIDEO_CALL_CONNECTED_SUCESS: 'PHYSICIAN_VIDEO_CALL_CONNECTED_SUCESS',
            VIDEO_CALL_END_CLICKED: 'VIDEO_CALL_END_CLICKED',
            VIDEO_CALL_END_SUCESSS: 'VIDEO_CALL_END_SUCESSS',
            VIDEO_CALL_END_ERROR: 'VIDEO_CALL_END_ERROR',
            VIDEO_CALL_GET_CHAT_CLICKED: 'VIDEO_CALL_GET_CHAT_CLICKED',
            VIDEO_CALL_GET_CHAT_SUCESSS: 'VIDEO_CALL_GET_CHAT_SUCESSS',
            VIDEO_CALL_GET_CHAT_ERROR: 'VIDEO_CALL_GET_CHAT_ERROR',
            VIDEO_CALL_SENDER_RECEVIER_IMAGE: 'VIDEO_CALL_SENDER_RECEVIER_IMAGE',
            PHYSICIAN_ISONLINE: 'physician_isonline',
            VIDEO_CALL_START_RECORD_CLICKED: 'VIDEO_CALL_START_RECORD_CLICKED',
            VIDEO_CALL_START_RECORD_SUCESSS: 'VIDEO_CALL_START_RECORD_SUCESSS',
            VIDEO_CALL_START_RECORD_ERROR: 'VIDEO_CALL_START_RECORD_ERROR',
            VIDEO_CALL_STOP_RECORD_CLICKED: 'VIDEO_CALL_STOP_RECORD_CLICKED',
            VIDEO_CALL_STOP_RECORD_SUCESSS: 'VIDEO_CALL_STOP_RECORD_SUCESSS',
            VIDEO_CALL_STOP_RECORD_ERROR: 'VIDEO_CALL_STOP_RECORD_ERROR',
            ON_MESSAGE_RECEVICE: 'ON_MESSAGE_RECEVICE',
            ON_MESSAGE_SEND_CLICKED: 'ON_MESSAGE_SEND_CLICKED',
            ON_MESSAGE_SEND_SUCESSS: 'ON_MESSAGE_SEND_SUCESSS',
            ON_MESSAGE_SEND_ERROR: 'ON_MESSAGE_SEND_ERROR',
            UNREAD_COUNT_ADD: 'UNREAD_COUNT_ADD',
            UNREAD_COUNT_CLEAR: 'UNREAD_COUNT_CLEAR',
            SAVE_SOAP_CLICKED: 'SAVE_SOAP_CLICKED',
            SAVE_SOAP_SUCESSS: 'SAVE_SOAP_SUCESSS',
            SAVE_SOAP_ERROR: 'SAVE_SOAP_ERROR',
            GET_ENCOUNTER_CLICKED: 'GET_ENCOUNTER_CLICKED',
            GET_ENCOUNTER_SUCESSS: 'GET_ENCOUNTER_SUCESSS',
            GET_ENCOUNTER_ERROR: 'GET_ENCOUNTER_ERROR',
            GET_ENCOUNTER_NOT_FOUND: 'GET_ENCOUNTER_NOT_FOUND',
            SOAP_NOTE_UPDATE: 'SOAP_NOTE_UPDATE',
            PATIENT_HANDOUT_UPDATE: 'PATIENT_HANDOUT_UPDATE',
            GET_ENCOUNTER_DATES_SUCESS: 'GET_ENCOUNTER_DATES_SUCESS',
            GET_ENCOUNTER_DATES_NO_DATA: 'GET_ENCOUNTER_DATES_NO_DATA',
            SAVE_SCREEN_SHOT_CLICKED: 'SAVE_SCREEN_SHOT_CLICKED',
            SAVE_SCREEN_SHOT_SUCESSS: 'SAVE_SCREEN_SHOT_SUCESSS',
            SAVE_SCREEN_SHOT_ERROR: 'SAVE_SCREEN_SHOT_ERROR',
            APPOINTMENT_BOOKING_CONFIRMATION: 'APPOINTMENT_BOOKING_CONFIRMATION',
            ONDEMAND_BOOKING_CONFIRMATION: 'ONDEMAND_BOOKING_CONFIRMATION',
            DASHBOARD_APPOINTMENT: 'DASHBOARD_APPOINTMENT',
            LIVE_STREAM_PARTICIPANTS: 'LIVE_STREAM_PARTICIPANTS',
            RECORDING_CALL: 'RECORDING_CALL',
        },
        EDUCATOR: {
            GET_SUBJECT_LIST: 'GET_SUBJECT_LIST',
            GET_SUBCATEGORY_LIST: 'GET_SUBCATEGORY_LIST',
            GET_STUDENT_LIST: 'GET_STUDENT_LIST',
            GET_EDUCATOR_DETAILS: 'GET_EDUCATOR_DETAILS',
            UPDATE_EDUCATOR_PROFILE: 'UPDATE_EDUCATOR_PROFILE',
            GET_STUDENT_INFO_DATE: 'GET_STUDENT_INFORMATION',
        },
        PATIENT: {
            SHOWTIMER: 'SHOWTIMER',
            DASHBOARD: 'DASHBOARD',
            GET_PHYSICIAN_AVAILABILITY: 'GET_PHYSICIAN_AVAILABILITY',
            GET_VISIT_INFORMATION: 'GET_VISIT_INFORMATION',
            PHYSICIAN_CAMERA_ON: 'PHYSICIAN_CAMERA_ON',
            PHYSICIAN_CAMERA_OFF: 'PHYSICIAN_CAMERA_OFF',
            DASHBOARD_APPOINTMENT: 'DASHBOARD_APPOINTMENT',
        },
        STUDENT: {
            GET_SUBJECT_LIST: 'GET_SUBJECT_LIST',
            GET_SUBCATEGORY_LIST: 'GET_SUBCATEGORY_LIST',
            GET_EDUCATOR_LIST: 'GET_EDUCATOR_LIST',
            GET_EDUCATOR_AVAILABILITY: 'GET_EDUCATOR_AVAILABILITY',
            POST_ONDEMAND: 'POST_ONDEMAND',
            GET_STUDENT_DETAILS: 'GET_STUDENT_DETAILS',
            UPDATE_STUDENT_PROFILE: 'UPDATE_STUDENT_PROFILE',
            CHAT_MESSAGES_LIST: 'CHAT_MESSAGES_LIST',
            CLEAR_CHAT_MESSAGES_LIST: 'CLEAR_CHAT_MESSAGES_LIST',
            GET_STUDENTS_EDUCATOR: 'GET_STUDENTS_EDUCATOR',
            GET_STUDENTS_EDUCATOR_SUBJECT: 'GET_STUDENTS_EDUCATOR_SUBJECT',
        },
    },
    PATH: {
        AUTH: '/auth',
        INDEX: '/',
        FORGET_PASSWORD: '/forget-password',
        PRIVACY_POLICY: '/privacy/policy',
        CHANGE_PASSWORD: '/change-password',
        NOT_FOUND: '/page/not-found',
        GUEST: {
            GUEST_WAITINGROOM: '/guest/appointment/waiting-room',
        },
        IM_PHYSICIAN: {
            VERIFY_EMAIL: `/${Producer}/verify-email`,
            CHANGE_PASSWORD: `/${Producer}/change-password`,
            ENROLL_PHYSICIAN: `/${Producer}/enroll-physician-information`,
            DASHBOARD: `/${Producer}/dashboard`,
            MANAGE_SCHEDULE: `/${Producer}/manage-schedule`,
            APPOINTMENT: `/${Producer}/appointment`,
            WAITINGROOM: `/${Producer}/appointment/waiting-room`,
            MY_PROFILE: `/${Producer}/my-profile`,
            VIDEO_CALL: `/${Producer}/video-call`,
            MY_STUDENTS: `/${Producer}/team`,
            PAYMENT: `/${Producer}/payment`,
            SUMMARY: `/${Producer}/summary`,
            PRESCRIBE: `/${Producer}/prescribe`,
            FINANCIAL_REPORT: `/${Producer}/financial-report`,
            ADD_NOTES: `/${Producer}/appointment`,
            REFERRAL: `/${Producer}/referral`,
            SUBJECT_REFERRAL_SUMMARY: `/${Producer}/subject-referral/summary`,
            MESSAGES: `/${Producer}/messages`,
        },
        IM_PATIENT: {
            MYPATHOLOGIST: '/patient/provider/pathologist',
            MYPHARMACIST: '/patient/provider/pharmacist',
            PATHOLOGIST_APPOINTMENT: `/patient/appointment/pathologist`,
            PHARMACIST_APPOINTMENT: `/patient/appointment/pharmacist`,
            VIEWENCOUNTER: `/${Consumer}/encounter`,
            VIEW_ENCOUNTER_DETAILS: `/${Consumer}/encounter-list`,

            CHANGE_PASSWORD: `/${Consumer}/change-password`,
            ENROLL_PATIENT: `/${Consumer}/enroll-student-information`,
            DASHBOARD: `/${Consumer}/dashboard`,
            MYPROVIDER: `/${Consumer}/${Producer}/${Producer}`,
            PROVIDER_LIST: `/${Consumer}/provider-list`,
            ONDEMAND: `/${Consumer}/ondemand`,
            APPOINTMENT_BOOKING: `/${Consumer}/appointment-booking`,
            APPOINTMENT: `/${Consumer}/appointment/${Producer}`,
            CREATE_APPOINTMENT: `/${Consumer}/appointment/${Producer}`,
            WAITINGROOM: `/${Consumer}/appointment/${Producer}/waiting-room`,
            MY_PROFILE: `/${Consumer}/my-profile`,
            VIDEO_CALL: `/${Consumer}/video-call`,
            SUBJECT_REFERRAL_SUMMARY: `/${Consumer}/subject-referral/summary`,
            MESSAGES: `/${Consumer}/messages/${Producer}`,
        },
        LEVEL_TWO_ADMIN: {
            VIDEO_CALL: `/${LevelTwo}/video-call`,
        },
    },
    VALIDATION_MSG: {
        REQ_FAILED: 'Request failed.',
        AUTH_FAILED: 'The username and password you entered does not match.',
        NO_INTERNET: 'Please Check Your Internet connection',
        NO_DATA_FOUND: 'Could not fetch data from the server',
    },
    ALERT: {
        TITLE: {
            APP_NAME: 'VirtuOwl',
        },
    },
    MESSAGE: {
        STATUS_CODE_401_ERROR: 'Access denied for this request',
    },
};
